export default __webpack_public_path__ + "static/media/download_appstore.51bcd50a.png";